import { Button, Page } from '@ui/themed';
import { t } from 'i18next';
import { useState } from 'react';
import { Checklist } from '../../../../components/checklist';
import { useHandlers, withPageProviders } from '../../../../context/page-context';
import { useStorageKey } from '../../../../context/use-storage-key';
import { useConfetti } from '../../../../hooks/use-confetti';
import { showIntercom } from '../../../../lib/intercom';
import { useSetupSteps } from '../use-setup-steps';

export const SetupPage = withPageProviders(() => {
  const steps = useSetupSteps();
  const storageKey = useStorageKey('setup');
  const { navigationHandler } = useHandlers();
  const { celebrate, finale } = useConfetti();
  const [isJustCompleted, setIsJustCompleted] = useState<boolean>(false);

  return (
    <Page
      title={t('features:onboarding.pages.setup_page.title')}
      description={t('features:onboarding.pages.setup_page.description')}
    >
      <Checklist
        gated={false}
        storageKey={storageKey}
        progress={{
          // Setup is unordered, so the bar fills by count (leading pills), not by item position.
          title({ completed, isComplete }) {
            if (isComplete) return t('features:onboarding.pages.setup_page.progress_done');
            return completed > 0
              ? t('features:onboarding.pages.setup_page.progress_mid')
              : t('features:onboarding.pages.setup_page.progress_start');
          },
        }}
        actions={
          <Button variant="bare" size="sm" onClick={showIntercom}>
            {t('features:onboarding.pages.tutorial_page.get_help')}
          </Button>
        }
        onItemComplete={(event) => celebrate({ anchor: event.element })}
        onAllComplete={() => {
          setIsJustCompleted(true);
          finale();
        }}
      >
        {steps.map((stepProps) => (
          <Checklist.Item key={stepProps.id} {...stepProps} />
        ))}
      </Checklist>
      {isJustCompleted && (
        <div className="flex justify-end">
          <Button
            variant="primary"
            icon="arrowRight"
            // TODO: on release of the try-it-out tutorial, this should navigate to that instead of home.
            onClick={() => navigationHandler.navigateById('home')}
          >
            {t('features:onboarding.pages.setup_page.complete')}
          </Button>
        </div>
      )}
    </Page>
  );
});
